export class FileDTO 
{
  ID:number;
  IDEncyrpted:string;
  ID_GUID:string;
  MimeType:string;
  _NameWithExtension:string;
  CorrelationId:string;
  Modified:Date;
  ModifiedBy:string;
  FontAwesomeClass:string;
  ProviderName:string;
  Tags:string
  FileName: string;
  FileType: string;
  FileBase64:string;
  FileBytes:string;
  FileSizeInMB: number;
}